import HomeOutlinedIcon from '@mui/icons-material/HomeOutlined';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import { alpha, Box, Breadcrumbs, Container, IconButton, Typography } from '@mui/material';
import { LinkI18n } from '../i18n/routing';

interface LinkPart {
  href?: string;
  title: string;
}

export interface BannerBreadcrumbsProps {
  section?: string;
  subSection?: string;
  linkParts?: LinkPart[];
  currentTitle: string;
  disableContainer?: boolean;
  rootUrl?: string;
  tint?: string;
}

export function BannerBreadcrumbs(props: BannerBreadcrumbsProps) {
  const {
    rootUrl = '/',
    disableContainer = false,
    section,
    subSection,
    linkParts = [],
    currentTitle,
    tint = '#fff',
  } = props;
  return (
    <Box
      className="BannerBreadcrumbs-root"
      sx={{
        py: 0,
        px: 1,
        '& .MuiTypography-root': {
          color: tint,
        },
        '& .MuiBreadcrumbs-li > a': {
          textDecoration: 'none',
          color: tint,
          fontWeight: 300,
          fontSize: '0.9rem',
        },
      }}
    >
      <Container disableGutters maxWidth={disableContainer ? false : 'lg'}>
        <Breadcrumbs
          separator={<NavigateNextIcon fontSize="small" />}
          aria-label="breadcrumb"
          sx={{
            pt: 1,
            '& .MuiBreadcrumbs-separator': {
              color: alpha(tint, 0.7),
            },
          }}
        >
          <IconButton
            href={rootUrl}
            color="default"
            size="large"
            sx={{
              p: 0.5,
              '& svg': {
                color: tint,
              },
            }}
          >
            <HomeOutlinedIcon sx={{ width: 20 }} />
          </IconButton>
          {section && (
            <Typography
              sx={{
                fontWeight: 300,
                fontSize: '0.9rem',
              }}
            >
              {section}
            </Typography>
          )}

          {subSection && (
            <Typography
              sx={{
                fontWeight: 300,
                fontSize: '0.9rem',
              }}
            >
              {subSection}
            </Typography>
          )}

          {linkParts
            .map((it, i) => ({ ...it, key: i }))
            .map(({ href, title, key }) =>
              href ? (
                <LinkI18n key={key} href={href}>
                  {title}
                </LinkI18n>
              ) : (
                <Typography key={key}>{title}</Typography>
              ),
            )}

          <Typography
            style={{
              fontSize: '0.9rem',
            }}
          >
            {currentTitle}
          </Typography>
        </Breadcrumbs>
      </Container>
    </Box>
  );
}
